<template>
  <b-container fluid class="mt-5">
    <b-card :header="$t('task.info')">
      <p class="card-text">
        <label
          ><strong>{{ $t("task.description") }}:</strong></label
        >
        {{ event.description }}
        <br />
        <label
          ><strong>{{ $t("task.dueDate") }}:</strong></label
        >
        {{ event.task.dueDate | date }}<br />
      </p>
      <b-list-group
        v-if="event.files && event.files.length > 0 && !event.task.expired"
      >
        <b-list-group-item
          v-for="(file, idx) in event.files"
          :key="idx"
          class="d-flex justify-content-between align-items-center"
        >
          {{ file.name }}
          <b-button
            variant="link"
            :href="`/api/events/${token}/file/${file._id}`"
            target="_blank"
          >
            <i class="fa fa-download" aria-hidden="true"></i> Download
          </b-button>
        </b-list-group-item>
      </b-list-group>
    </b-card>
    <b-card v-if="event.task.expired">
      <h3 class="text-center">{{ $t("task.expired") }}</h3>
    </b-card>
    <b-card v-else-if="finished" no-header>
      <h3 class="text-center">{{ $t("task.success") }}</h3>
    </b-card>
    <b-card v-else :header="$t('task.response')" no-body>
      <b-card-body>
        <b-form-group
          :label="$t('task.fields.text')"
          :description="$t('task.fieldsDesc.text')"
        >
          <b-form-textarea
            v-model="response"
            v-validate="{ required: true }"
            class="form-control"
            aria-describedby="invalidText"
            name="response"
            :rows="4"
            :state="validateState('response')"
          />
          <b-form-invalid-feedback id="invalidText">
            {{ errors.first("response") }}
          </b-form-invalid-feedback>
        </b-form-group>
        <h6>{{ $t("task.attachments") }}</h6>
        <small class="pt-1 pb-1 form-text text-muted">{{
          $t("task.attachmentInfo")
        }}</small>
        <multiple-file-upload
          ref="upload"
          :post-action="upload.postAction"
          :data="upload.data"
          :disabled="uploading || uploadComplete"
          @upload-complete="onUploadComplete"
        />
      </b-card-body>
      <b-card-footer class="d-flex justify-content-center">
        <b-button variant="primary" @click="submit">{{
          $t("task.send")
        }}</b-button>
      </b-card-footer>
    </b-card>
  </b-container>
</template>

<script>
import { getTaskInfo, sendTaskResponse } from "@/api/main";
import MultipleFileUpload from "../../../components/MultipleFileUpload";
import { mapGetters } from "vuex";

export default {
  name: "CompanyTask",
  components: {
    MultipleFileUpload,
  },
  props: {
    token: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      event: { task: {} },
      uploading: false,
      uploadComplete: false,
      upload: {
        postAction: "",
        data: {},
      },
      response: "",
      loader: null,
      finished: false,
    };
  },
  computed: {
    ...mapGetters(["company"]),
  },
  async created() {
    this.loader = this.$loading.show();
    try {
      const response = await getTaskInfo(this.token);
      this.event = response.data;
    } catch (e) {
      if (e?.response?.status === 404) {
        await this.$router.replace("/404");
        return;
      }
      throw e;
    } finally {
      this.loader.hide();
    }
  },

  methods: {
    validateState(ref) {
      if (
        this.vFields[ref] &&
        (this.vFields[ref].dirty || this.vFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    async onUploadComplete() {
      this.uploadComplete = true;
      this.uploading = false;
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.onTaskFinished();
        });
      });
    },
    async submit() {
      if (!this.$refs.upload.hasInvalidFiles) {
        if (await this.$validator.validateAll()) {
          this.loader = this.$loading.show();
          await this.handleTaskSubmit();
        }
      }
    },
    async handleTaskSubmit() {
      try {
        const response = await sendTaskResponse(this.token, this.response);
        if (response.status === 201) {
          const files = this.$refs.upload.selectedFiles();
          if (files.length > 0) {
            this.uploading = true;

            this.upload.postAction = `/api/events/${this.token}/file`;
            for (const file of files) {
              file.postAction = this.upload.postAction;
              file.headers = this.upload.headers;
            }

            this.$nextTick(() => this.$refs.upload.start());
          } else {
            this.onTaskFinished();
          }
        }
      } catch (error) {
        this.loader.hide();
        if (
          error?.response.status === 403 ||
          error?.response.status === 400 ||
          error?.response.status === 404
        ) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
      }
    },
    onTaskFinished() {
      this.finished = true;
      this.loader.hide();
      this.$bvToast.toast(this.$i18n.t("task.success"), {
        title: "Sucesso",
        toastClass: "custom-toast custom-toast-success",
        variant: "light",
        solid: true,
        autoHideDelay: 5000,
        noCloseButton: false,
      });
    },
  },
};
</script>
